import React from 'react';

import SesamLink from '../common/Links/SesamLink';
import { Form, FormActions } from '../common/forms';

import { TestID } from '../../testID';

import './ConnectMessages.scss';

export const ProvisioningFailed: React.FC<{
  subId: string;
}> = ({ subId }) => (
  <>
    <h2
      className="connect-message-title"
      data-testid={TestID.ConnectToSubscriptionProvisioningFailedMessage}
    >
      Provisioning failed
    </h2>

    <Form component="div">
      <FormActions>
        <SesamLink to={`/subscription/${subId}/settings-subscription/network`}>
          Go to network settings
        </SesamLink>
      </FormActions>
    </Form>
  </>
);
